import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dayforce = defineConnector({
  identifier: "dayforce",
  name: "Dayforce",
  tagLine: "HCM and workforce management",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://[^/]*\\.dayforcehcm\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Get your Dayforce API credentials",
      items: [
        {
          kind: "markdown",
          content: `1. In Dayforce, go to **System Admin › API Management**
2. Register a new client application
3. Copy the **username** and **password** for the API user`,
        },
      ],
    },
    {
      title: "Enter your Dayforce details",
      items: [
        {
          kind: "input",
          label: "Company namespace",
          required: true,
          placeholder: "acme",
          target: { kind: "configuration", field: "namespace" },
          helperText:
            "Your Dayforce company namespace (e.g., “acme” for acme.dayforcehcm.com).",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "secrets", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ namespace }) =>
      `https://usr${namespace}.dayforcehcm.com/Api/${namespace}/V1/Employees?$top=1`,
  },
});
